import { useScriptTag } from '@vueuse/core';
import { noop } from '../utils/component-lib.esm.js';
import { defaultWindow } from '../utils/component-lib.esm2.js';
const FACEBOOK_SDK_URL = 'https://connect.facebook.net/en_US/sdk.js#xfbml=0&version=v3.2';
let hasLoaded = false;
function useFacebookSdk() {
  let onLoaded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
  const window = defaultWindow;

  // only load the SDK once
  if (hasLoaded && window && window.FB) onLoaded(window.FB);else {
    useScriptTag(FACEBOOK_SDK_URL, () => {
      hasLoaded = true;
      onLoaded(window.FB);
    });
  }
}
export { useFacebookSdk };